enum AvailabilityRestriction {
    None = 0,
    Uk48HourDirective = 1,
    Uk20HourStudentVisa = 2
}

export default AvailabilityRestriction;